import { type ForwardedRef, forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

import type { BaseTemplateInputHandle } from './BaseTemplateInput/BaseTemplateInput'
import WrappedBaseTemplateInput, {
  type WrappedBaseTemplateInputProps,
} from './WrappedBaseTemplateInput'

export interface NotesTemplateInputProps
  extends Omit<WrappedBaseTemplateInputProps, 'filter'> {}

const NotesTemplateInput = forwardRef(function NotesTemplateInput(
  props: NotesTemplateInputProps,
  ref: ForwardedRef<BaseTemplateInputHandle>,
) {
  const { t } = useTranslation('Common')

  const isDefaultSoapNotesTemplatesEnabled = useSelector(
    getFeatureToggle(FeatureToggle.SET_DEFAULT_SOAP_NOTE_TEMPLATES),
  )

  return (
    <WrappedBaseTemplateInput
      filter={
        isDefaultSoapNotesTemplatesEnabled
          ? [
              'Medical notes template',
              'Discharge notes template',
              'Notes template',
            ]
          : ['Notes template']
      }
      label={t('Common:NOTES_TEMPLATE')}
      ref={ref}
      {...props}
    />
  )
})

export default NotesTemplateInput
